export interface ICholesterolReading {
  readingId: number;
  lowDensityLipids: number;
  highDensityLipids: number;
  triglycerides: number;
  totalCholesterol: number;
  patientId: number;
  readingTime: string;
  dateCreated: string;
  dateUpdated: string;
}

export interface ICholesterolReadingDTO {
  patientId: number;
  lowDensityLipids: number;
  highDensityLipids: number;
  triglycerides: number;
  totalCholesterol: number;
  readingDate: string;
  readingTime: string;
}

export const defaultCholesterolReading: ICholesterolReadingDTO = {
  patientId: 0,
  lowDensityLipids: 1,
  highDensityLipids: 1,
  triglycerides: 1,
  totalCholesterol: 1,
  readingDate: new Date().toISOString().split('T')[0],
  readingTime: new Date().toLocaleTimeString(),
};
